import React from 'react';
import { Button, Card, Flex, Grid, Typography, theme } from 'antd';
import { GoogleOutlined } from '@ant-design/icons';

import SearchPerformanceInfoPanel from './SearchPerformanceInfoPanel';

const BENEFITS = [
  'See how the pages Prerender serves actually perform in Google Search',
  'Find the sections where your pages are not showing up',
  'Check one URL against Prerender and Google side by side',
];

type Props = {
  isConnecting: boolean;
  onConnect: () => void;
};

function SearchPerformanceAuthStep({ isConnecting, onConnect }: Props) {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();
  const isNarrow = !screens.lg;

  return (
    <Card title="Unlock Google Search Console in Search Performance">
      <Flex vertical={isNarrow} gap={token.marginLG} align={isNarrow ? 'stretch' : 'flex-start'}>
        <Flex vertical flex={1} align="center" gap={token.margin}>
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: 128, // FIXME: no exact token
              borderRadius: token.borderRadius,
              overflow: 'hidden',
            }}
          >
            <img
              src="/img/sp-illustration-bg.svg"
              alt=""
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <Flex align="center" justify="center" gap={token.marginSM} style={{ position: 'relative', height: '100%' }}>
              <img src="/img/sp-seo-icon.png" alt="SEO" style={{ width: 100, height: 100 }} />{' '}
              {/* FIXME: no exact token */}
              <img src="/img/sp-shuffle-arrows.png" alt="" style={{ width: 48, height: 48 }} />{' '}
              {/* FIXME: no exact token */}
              <svg
                width="70"
                height="50"
                viewBox="0 0 35.5 25.5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-label="Prerender"
              >
                <path
                  d="M13.1368 1.558L8.1522 7.07405L7.12685 5.93938C6.67865 5.44339 6.67865 4.63923 7.12685 4.14324L10.4884 0.423328C10.9366 -0.0726643 11.6633 -0.0726626 12.1115 0.423329L13.1368 1.558Z"
                  fill={token.colorPrimary}
                />
                <path
                  d="M8.13308 18.0106L13.1177 23.5267L12.1115 24.6402C11.6633 25.1362 10.9366 25.1362 10.4884 24.6402L7.12685 20.9203C6.67864 20.4243 6.67864 19.6202 7.12685 19.1242L8.13308 18.0106Z"
                  fill={token.colorPrimary}
                />
                <path
                  d="M6.36445 9.05241L4.89192 10.6819C3.95815 11.7153 3.95816 13.3906 4.89192 14.4239L6.33057 16.016L5.32077 17.1334C4.87256 17.6294 4.14587 17.6294 3.69767 17.1334L0.336154 13.4135C-0.112052 12.9175 -0.112051 12.1134 0.336155 11.6174L3.69767 7.89745C4.14588 7.40146 4.87256 7.40146 5.32077 7.89745L6.36445 9.05241Z"
                  fill={token.colorPrimary}
                />
                <path
                  d="M19.4932 1.62551L14.5086 7.14157L13.4223 5.93938C12.9741 5.44339 12.9741 4.63923 13.4223 4.14324L16.7838 0.423328C17.232 -0.0726643 17.9587 -0.0726626 18.4069 0.423329L19.4932 1.62551Z"
                  fill={token.colorPrimary}
                />
                <path
                  d="M14.4895 17.9431L19.4741 23.4592L18.4069 24.6402C17.9587 25.1362 17.232 25.1362 16.7838 24.6402L13.4222 20.9203C12.974 20.4243 12.974 19.6202 13.4223 19.1242L14.4895 17.9431Z"
                  fill={token.colorPrimary}
                />
                <path
                  d="M12.7209 9.11992L11.3093 10.6819C10.3756 11.7153 10.3756 13.3906 11.3093 14.4239L12.687 15.9484L11.6162 17.1334C11.168 17.6294 10.4413 17.6294 9.99307 17.1334L6.63156 13.4135C6.18335 12.9175 6.18335 12.1134 6.63156 11.6174L9.99308 7.89745C10.4413 7.40146 11.168 7.40146 11.6162 7.89745L12.7209 9.11992Z"
                  fill={token.colorPrimary}
                />
                <path
                  d="M23.3101 0.371995C23.7583 -0.123997 24.485 -0.123999 24.9332 0.371994L34.5879 11.0561C35.335 11.8828 35.335 13.2231 34.5879 14.0497L24.9332 24.7339C24.485 25.2299 23.7583 25.2299 23.3101 24.7339L13.1142 13.451C12.666 12.955 12.666 12.1508 13.1142 11.6549L23.3101 0.371995Z"
                  fill={token.colorPrimary}
                />
              </svg>
            </Flex>
          </div>

          <Typography.Text style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, textAlign: 'center' }}>
            We ask for read-only access. No changes will be made to your Google account.
          </Typography.Text>

          <Button
            size="large"
            loading={isConnecting}
            icon={<GoogleOutlined />}
            style={{ width: '100%', maxWidth: 333 }}
            onClick={onConnect}
          >
            Log in with Google
          </Button>
        </Flex>

        <SearchPerformanceInfoPanel title="Why connect Google Search Console?" items={BENEFITS} fullWidth={isNarrow} />
      </Flex>
    </Card>
  );
}

export default SearchPerformanceAuthStep;
